export const getUrl = (path: string) =>
	(process.env.GATSBY_API_LINK ? (typeof window !== 'undefined' ? `${new URL(window.location.href).origin}/api/` : '') : 'http://localhost:8080/') +
	path
